import React from 'react';
import PropTypes from 'prop-types';
import Joi from 'joi';

import Form from '../../common/form';
import toastService from '../../../services/toastService';
import { MATERIAL_OPTIONS } from '../../../utils/constants';

interface StateData {
	executiveSummary: string;
	material: string;
	recommendation: string;
};

interface Props {
	initialSummaryData: StateData,
	onAdd: (summaryData: StateData) => void;
}

class CustomPECSummaryForm extends Form {
	state: any = {
		data: {
			executiveSummary: '',
			material: '',
			inspectionType: '',
			recommendation: 'NIL',
		},
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
		material: Joi.string().min(5).required().label('Material'),
		executiveSummary: Joi.string().optional().label('Executive Summary'),
		inspectionType: Joi.string().optional().label('Inspection Type'),
		recommendation: Joi.string().min(3).required().label('Recommendation'),
	};

	static propTypes = {
		initialSummaryData: PropTypes.object,
		onAdd: PropTypes.func,
	}

	componentDidMount() {
		if (this.props.initialSummaryData) {
			this.setState({ data: this.props.initialSummaryData });
		}
	}

	componentDidUpdate(prevProps: Props, prevState: { data: StateData }) {
		if (prevProps.initialSummaryData && this.props.initialSummaryData) {
			if (prevProps.initialSummaryData === this.props.initialSummaryData) return;

			this.setState({ data: this.props.initialSummaryData });
		}
	}

	doSubmit = () => {
		this.props.onAdd(this.state.data);
		toastService.success('Summary saved successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderSelect({
					options: MATERIAL_OPTIONS,
					name: 'material',
					label: 'Material',
					placeholder: 'Select Material',
				})}

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderTextArea({
							name: 'executiveSummary',
							label: 'Executive Summary',
							rows: '4',
							placeholder: 'Enter executive summary',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							options: INSPECTION_OPTIONS,
							name: 'inspectionType',
							label: 'Inspection Type',
							placeholder: 'Select Inspection Type',
						})}
					</div>

					<div className="col">
						{this.renderTextArea({
							rows: '4',
							name: 'recommendation',
							label: 'Remark (If any)',
							placeholder: 'Enter Remark',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Summary Sheet Data')}
				</div>
			</form>
		);
	}
}

const INSPECTION_OPTIONS = [
	{
		id: 'piping',
		name: 'Piping',
	},
	{
		id: 'vessel',
		name: 'Vessel',
	}
];

export default CustomPECSummaryForm;
